import * as dto from '@epicuro-next/data/baskets-dto';
import { mapProductId } from '@epicuro-next/utilities';
import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

import {
  getNestedObjects,
  GetRowsFn,
  GroupingFn,
  groupItemsByArticle,
  Mappings,
} from '../mappings';

/**
 * Third level grouping by articles.
 * For 2 levels hierarchy it's empty.
 */
export function groupByArticle(
  items: dto.Item[],
  maps: Mappings,
  groupFn?: GroupingFn,
  getRowsFn?: GetRowsFn,
): BasketRowsGroup[] {
  const itemsMap = groupItemsByArticle(items, maps.products);

  return Object.keys(itemsMap).map((articleKey) => {
    const articleItems = itemsMap[articleKey];
    const article = maps.products[articleKey];
    const nested = getNestedObjects(articleItems, maps, groupFn, getRowsFn);
    return {
      id: article.productId,
      type: BasketRowsGroupType.Article,
      title: article.title,
      subTitle: maps.settings?.showIdInArticleGroup
        ? mapProductId(article.productId, maps.settings?.additionalPrefix)
        : undefined,
      ...nested,
    };
  });
}
